import { useBrowserTitleStore } from "client_legacy/ndaw/browserTitle";
import {
	ReactElement,
	useMemo
} from "react";
import {
	isNotNilOrEmpty,
	setTrackingId
} from "client/Misc/utils";
import styles from "./ResponsiveTitle.module.less";
import { useResponsiveTitleStore } from "./responsiveTitleStore";

export const ResponsiveTitle = (): ReactElement => {
	const pageTitle: string = useBrowserTitleStore(x => x.title);

	const customTitle: string | undefined = useResponsiveTitleStore(x => x.customTitle);

	const title = useMemo(
		(): string => {
			if (isNotNilOrEmpty(customTitle)) {
				return customTitle;
			}

			return pageTitle;
		},
		[
			customTitle,
			pageTitle
		]
	);

	return (
		<h4
			className={styles.root}
			{...setTrackingId("mobile-page-title")}
		>
			{title}
		</h4>
	);
};
ResponsiveTitle.displayName = "ResponsiveTitle";